<template>
  <div class="liu pos-manage">
    <mt-header fixed :title="title" class="title2">
      <mt-button slot="left" icon="back" @click="onBackBtnClick">返回</mt-button>
    </mt-header>
    <div class="scroll-container" :style="customScrollHeight">
      <!-- 营业执照奖励设置 -->
      <div class="big-item" @click="rewardMoneyVisibleChange" style="margin-top:20px;width:80%;padding:1rem 0;">
        <div class="big-item-col img-col">
          <img class="img" src="../../assets/task_setting1.png" alt="">
          <span class="title">营业执照</span>
        </div>
        <div class="big-item-col txt-col">
          <span class="smallSpan">○ 激活奖励</span>
          <span class="smallSpan">○ 达标奖励</span>
          <span class="smallSpan">○ 优质商户奖励</span>
          <span class="smallSpan">○ 码牌(音箱)达标奖励</span>
          <span class="smallSpan">○ 码牌(音箱)优质商户奖励</span>
        </div>
      </div>
      <!-- 小微奖励设置 -->
      <div class="big-item" @click="XWMoneyVisibleChange" style="background-color:#3782dc!important;margin-top:0.95rem;width:80%;padding:1rem 0;">
        <div class="big-item-col img-col">
          <img class="img" src="../../assets/task_setting2.png" alt="">
          <span class="title">小微商户</span>
        </div>
        <div class="big-item-col txt-col">
          <span>○ 达标奖励</span>
          <span>&nbsp;</span>
          <span>&nbsp;</span>
        </div>
      </div>

      <!-- 营业执照奖励设置弹出框 -->
      <mt-popup v-model="BigPopVisible" position="right" style="height:100%" class="bg" closeOnClickModal="false">
        <mt-header fixed title="营业执照商户设置" class="title2"></mt-header>
        <!-- 金额修改显示 -->
        <div class="form mt-15" style="margin-top:54px">
          <!-- 激活奖励金额 -->
          <div class="row">
            <div class="item">
              <div class="label">
                <span>{{ rewardData.money1.label }}</span>
              </div>
              <div class="content" :class="{ sheet: agentLevel !== 1 }">
                <input type="text" v-model="rewardData.money1.value" readonly="readonly" placeholder="请选择" @click="firstBonusClick" />
                <div class="arrow" @click="firstBonusClick" v-if="agentLevel !== 1" />
              </div>
            </div>
          </div>
          <!-- 达标奖励金额 -->
          <div class="row">
            <div class="item">
              <div class="label">
                <span>{{ rewardData.money2.label }}</span>
              </div>
              <div class="content" :class="{ sheet: agentLevel !== 1 }">
                <input type="text" v-model="rewardData.money2.value" readonly="readonly" placeholder="请选择" @click="secondBonusClick" />
                <div class="arrow" @click="secondBonusClick" v-if="agentLevel !== 1" />
              </div>
            </div>
          </div>
          <!-- 优质商户奖励金额 -->
          <div class="row">
            <div class="item">
              <div class="label">
                <span>{{ rewardData.money3.label }}</span>
              </div>
              <div class="content" :class="{ sheet: agentLevel !== 1 }">
                <input type="text" v-model="rewardData.money3.value" readonly="readonly" placeholder="请选择" @click="thirdBonusClick" />
                <div class="arrow" @click="thirdBonusClick" v-if="agentLevel !== 1" />
              </div>
            </div>
          </div>
          <!-- 20220923 音箱达标奖励 -->
          <div class="row" v-if="rewardData.allowChangeSoundReward">
            <div class="item">
              <div class="label">
                <span :class="checkTextColor">{{ rewardData.audioMoney1.label }}</span>
              </div>
              <div class="content" :class="{ sheet: agentLevel !== 1 }">
                <input type="text" v-model="rewardData.audioMoney1.value" placeholder="请选择" readonly="readonly" @click="audioMoney1Click" :class="checkTextColor" />
                <div class="arrow" @click="audioMoney1Click" v-if="agentLevel !== 1" />
              </div>
            </div>
          </div>
          <!-- 20220923 音箱优质商户奖励 -->
          <div class="row" v-if="rewardData.allowChangeSoundReward">
            <div class="item">
              <div class="label">
                <span :class="checkTextColor">{{ rewardData.audioMoney2.label }}</span>
              </div>
              <div class="content" :class="{ sheet: agentLevel !== 1 }">
                <input type="text" v-model="rewardData.audioMoney2.value" placeholder="请选择" readonly="readonly" @click="audioMoney2Click" :class="checkTextColor" />
                <div class="arrow" @click="audioMoney2Click" v-if="agentLevel !== 1" />
              </div>
            </div>
          </div>
          <!-- 达标奖励额外奖金 -->
          <div class="row" v-if="agentLevel == 1">
            <div class="item">
              <div class="label">
                <span>{{ rewardData.money4.label }}</span>
              </div>
              <div class="content">
                <div @click="handleCheckBoxClick4" class="num-checkbox">
                  <svg-icon :icon-class="checkboxSvgPath4" class-name="cur-icon"></svg-icon><span :class="checkboxColor4">{{
                    rewardData.money4.showValue
                  }}</span>
                </div>
              </div>
            </div>
          </div>
          <!-- 优质商户连续达标额外奖金 -->
          <div class="row" v-if="agentLevel == 1">
            <div class="item">
              <div class="label">
                <span>{{ rewardData.money5.label }}</span>
              </div>
              <div class="content">
                <div @click="handleCheckBoxClick5" class="num-checkbox">
                  <svg-icon :icon-class="checkboxSvgPath5" class-name="cur-icon"></svg-icon><span :class="checkboxColor5">{{
                    rewardData.money5.showValue
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 按钮 -->
        <div class="more-button">
          <span class="white" @click="BigPopVisible=false">取消</span>
          <span class="blue" @click="onPageSubmitClick">保存</span>
        </div>
      </mt-popup>
      <!-- 金额修改弹窗 活动3 -->
      <mt-popup class="area-popup" v-model="selectVisible" position="bottom" closeOnClickModal="false">
        <mt-picker :slots="rewordMoneySlots" @change="rewordSlotChange" valueKey="label" :visibleItemCount="5" :showToolbar="true">
          <div class="tool-bar">
            <div class="tool-btn" @click="selectVisible = false">
              <span>关闭</span>
            </div>
            <div class="tool-btn" @click="handleSelectSave">
              <span>确定</span>
            </div>
          </div>
        </mt-picker>
      </mt-popup>
      <!-- 金额修改弹窗 活动1 -->
      <mt-popup class="area-popup" v-model="firstSelectVisible" position="bottom" closeOnClickModal="false">
        <mt-picker :slots="firstRewordMoneySlots" @change="firstRewordSlotChange" valueKey="label" :visibleItemCount="5" :showToolbar="true">
          <div class="tool-bar">
            <div class="tool-btn" @click="firstSelectVisible = false">
              <span>关闭</span>
            </div>
            <div class="tool-btn" @click="firstHandleSelectSave">
              <span>确定</span>
            </div>
          </div>
        </mt-picker>
      </mt-popup>
      <!-- 金额修改弹窗 活动2 -->
      <mt-popup class="area-popup" v-model="secondSelectVisible" position="bottom" closeOnClickModal="false">
        <mt-picker :slots="secondRewordMoneySlots" @change="secondRewordSlotChange" valueKey="label" :visibleItemCount="5" :showToolbar="true">
          <div class="tool-bar">
            <div class="tool-btn" @click="secondSelectVisible = false">
              <span>关闭</span>
            </div>
            <div class="tool-btn" @click="secondHandleSelectSave">
              <span>确定</span>
            </div>
          </div>
        </mt-picker>
      </mt-popup>
      <!-- 金额修改弹窗 音箱达标 -->
      <mt-popup class="area-popup" v-model="audioMoney1SelectVisible" position="bottom" closeOnClickModal="false">
        <mt-picker :slots="audioMoney1Slots" @change="audioMoney1SlotChange" valueKey="label" :visibleItemCount="5" :showToolbar="true">
          <div class="tool-bar">
            <div class="tool-btn" @click="audioMoney1SelectVisible = false">
              <span>关闭</span>
            </div>
            <div class="tool-btn" @click="audioMoney1HandleSelectSave">
              <span>确定</span>
            </div>
          </div>
        </mt-picker>
      </mt-popup>
      <!-- 金额修改弹窗 音箱优质商户 -->
      <mt-popup class="area-popup" v-model="audioMoney2SelectVisible" position="bottom" closeOnClickModal="false">
        <mt-picker :slots="audioMoney2Slots" @change="audioMoney2SlotChange" valueKey="label" :visibleItemCount="5" :showToolbar="true">
          <div class="tool-bar">
            <div class="tool-btn" @click="audioMoney2SelectVisible = false">
              <span>关闭</span>
            </div>
            <div class="tool-btn" @click="audioMoney2HandleSelectSave">
              <span>确定</span>
            </div>
          </div>
        </mt-picker>
      </mt-popup>

      <!-- 小微奖励设置弹出框 -->
      <mt-popup v-model="xwMoneyPopVisible" position="right" style="height:100%" class="bg" closeOnClickModal="true" :modal="true">
        <mt-header fixed title="小微商户设置" class="title2"></mt-header>
        <!-- 页面主体 -->
        <div>
          <!-- 金额修改显示 -->
          <div class="form mt-15" style="margin-top:54px">
            <!-- 小微达标奖金 -->
            <div class="row">
              <div class="item">
                <div class="label">
                  <span>小微达标奖励金额(元)</span>
                </div>
                <div class="content" @click="onXWMoneyClick" :class="{ sheet: agentLevel !== 0 }">
                  <input type="text" class="rate-text" placeholder="请选择" v-model="rewardData.xwmoney.value" readonly="readonly" @click="xwmoneyPopupClick">
                  <div class="arrow" @click="xwmoneyPopupClick" />
                </div>
              </div>
            </div>
          </div>
          <!-- 按钮 -->
          <div class="more-button">
            <span class="white" @click="xwMoneyPopVisible=false">取消</span>
            <span class="blue" @click="saveXWMoney">保存</span>
          </div>
        </div>
      </mt-popup>
      <!-- 小微popup金额选择 -->
      <mt-popup class="area-popup" v-model="xwSelectVisible" position="bottom" :closeOnClickModal="0">
        <mt-picker :slots="xwRewordMoneySlots" @change="xwSlotChange" valueKey="label" :visibleItemCount="5" :showToolbar="true">
          <div class="tool-bar">
            <div class="tool-btn" @click="xwSelectVisible = false">
              <span>关闭</span>
            </div>
            <div class="tool-btn" @click="xwHandleSelectSave">
              <span>确定</span>
            </div>
          </div>
        </mt-picker>
      </mt-popup>

    </div>
  </div>
</template>

<script>
import { formatMoneyToFen } from '@/utils/format';
import { CusToast, CusAlert, CusLoadingOpen, CusLoadingClose } from '@/utils/CustomToast';
import { SucceedHandle2, NotSucceedHandle } from '@/api/handle';
import { ShowTaskRewardSetting, ChangeTaskRewardSetting, ChangeXWSHTaskRewardSetting } from '@/api/manage';
import { validateMinMax, validateZhenMoney } from '@/utils/validate';
import SvgIcon from '@/components/SvgIcon';

export default {
  name: 'TaskRewardSettingEdit',
  comments: { SvgIcon },
  data() {
    return {
      abcd: false,
      rewordMoneySlots: [
        {
          flex: 1,
          values: [0],
          className: 'slot1',
          textAlign: 'center',
        },
      ],
      firstRewordMoneySlots: [
        // 激活奖励(活动1)的金额选择
        {
          flex: 1,
          values: [0],
          className: 'slot2',
          textAlign: 'center',
        },
      ],
      secondRewordMoneySlots: [
        // 达标奖励(活动2)的金额选择
        {
          flex: 1,
          values: [0],
          className: 'slot3',
          textAlign: 'center',
        },
      ],
      audioMoney1Slots: [
        // 音箱码牌达标奖励的金额选择
        {
          flex: 1,
          values: [0],
          className: 'slot4',
          textAlign: 'center',
        },
      ],
      audioMoney2Slots: [
        // 音箱码牌优质商户奖励的金额选择
        {
          flex: 1,
          values: [0],
          className: 'slot5',
          textAlign: 'center',
        },
      ],
      xwRewordMoneySlots: [
        // wx
        {
          flex: 1,
          values: [1],
          className: 'slot4',
          textAlign: 'center',
        },
      ],
      title: '设置代理商奖励',
      rewardData: {
        allowChangeReward: 1,
        allowChangeSoundReward: 1,
        money1: {
          label: '激活奖励金额(元)',
          value: '', // 给直接代理的金额
          state: '',
          resValue: '', // 金额可设置最大值
          minValue: '',
        },
        money2: {
          label: '达标奖励金额(元)',
          value: '',
          state: '',
          resValue: '',
          minValue: '',
        },
        money3: {
          label: '优质商户奖励金额(元)',
          value: '',
          state: '',
          resValue: '',
          minValue: '',
        },
        money4: {
          label: '达标奖励额外奖金(元)',
          value: '',
          state: '',
          showValue: 10,
        },
        money5: {
          label: '优质商户连续达标额外奖金(元)',
          value: '',
          state: '',
          showValue: 10,
        },
        xwmoney: {
          // 小微达标奖金
          value: '',
          minValue: '',
          maxValue: '',
          allowChangeActiveReward: 1, // 是否能设置
          resValue: '',
        },
        audioMoney1: {
          label: '码牌(音箱)达标奖励金额(元)',
          value: '',
          state: '',
          resValue: '',
          minValue: '',
        },
        audioMoney2: {
          label: '码牌(音箱)优质商户奖励金额(元)',
          value: '',
          state: '',
          resValue: '',
          minValue: '',
        },
      },
      checkboxSvgPath4: 'unselected_coupons',
      checkboxSvgPath5: 'unselected_coupons',
      checkboxColor4: 'unselected_color',
      checkboxColor5: 'unselected_color',
      checkTextColor: 'able_color',
      currentCheckedState4: false,
      currentCheckedState5: false,
      agentLevel: 1, // 代理等级,顶级代理是1
      selectVisible: false,
      firstSelectVisible: false,
      secondSelectVisible: false,
      xwSelectVisible: false,
      audioMoney1SelectVisible: false,
      audioMoney2SelectVisible: false,
      pickerRewardData: {
        // 当前picker中选中的数据
        currentSelect: 0,
        firstCurrentSelect: 0,
        secondCurrentSelect: 0,
        audioMoney1CurrentSelect: 0,
        audioMoney2CurrentSelect: 0,
        xwCurrentSelect: 0,
      },
      BigPopVisible: false,
      xwMoneyPopVisible: false,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.showTaskRewardSetting();
      this.agentLevel = parseInt(this.$route.query.agentlevel);
      // console.log("当前登录的代理等级是：", this.$route.query.agentlevel);
    });
  },
  computed: {
    customScrollHeight() {
      return `height:${window.innerHeight}px;`;
    },
  },
  methods: {
    /**
     * 将分格式成元，不保留小数
     * @param {number} val 金额
     */
    formatMoneyToYuanShow(val) {
      val = String(val).trim();
      val = isNaN(parseFloat(val)) ? 0 : parseFloat(val);
      return parseFloat(val / 100).toFixed(0);
    },
    // picker中数组
    pickerSlotsChange(max, min) {
      max = parseInt(max);
      min = parseInt(min);
      if (max > 0) {
        const newSlotValue = [];
        newSlotValue.push(max + '');
        while (max > min) {
          max = max - 10;
          newSlotValue.push(max + '');
        }
        return newSlotValue;
      }
    },
    XWpickerSlotsChange(data, min) {
      data = parseInt(data);
      min = parseInt(min);
      if (data > 0) {
        const newSlotValue = [];
        newSlotValue.push(data + '');
        while (data > min) {
          data = data - 1;
          newSlotValue.push(data + '');
        }
        return newSlotValue;
      }
    },
    audioPickerSlotsChange(max, min) {
      max = parseInt(max);
      min = parseInt(min);
      if (max > 0) {
        const newSlotValue = [];
        newSlotValue.push(max + '');
        while (max > min) {
          max = max - 50;
          newSlotValue.push(max + '');
        }
        return newSlotValue;
      }
    },
    // 活动1中picker金额选择
    firstRewordSlotChange(picker) {
      this.$nextTick(() => {
        this.pickerRewardData.firstCurrentSelect = picker.getSlotValue(0);
      });
    },
    secondRewordSlotChange(picker) {
      this.$nextTick(() => {
        this.pickerRewardData.secondCurrentSelect = picker.getSlotValue(0);
      });
    },
    // 小微达标金额选择
    xwSlotChange(picker) {
      this.$nextTick(() => {
        this.pickerRewardData.xwCurrentSelect = picker.getSlotValue(0);
      });
    },
    // 活动3picker中金额选择
    rewordSlotChange(picker) {
      this.$nextTick(() => {
        this.pickerRewardData.currentSelect = picker.getSlotValue(0);
      });
    },
    audioMoney1SlotChange(picker) {
      this.$nextTick(() => {
        this.pickerRewardData.audioMoney1CurrentSelect = picker.getSlotValue(0);
      });
    },
    audioMoney2SlotChange(picker) {
      this.$nextTick(() => {
        this.pickerRewardData.audioMoney2CurrentSelect = picker.getSlotValue(0);
      });
    },
    // 金额选择点击事件
    audioMoney1Click() {
      if (this.agentLevel === 1) return;
      if (this.rewardData.audioMoney1.resValue === '0') {
        this.audioMoney1Slots[0].values = [0];
      } else {
        this.audioMoney1Slots[0].values = this.audioPickerSlotsChange(this.rewardData.audioMoney1.resValue, this.rewardData.audioMoney1.minValue);
      }
      this.audioMoney1SelectVisible = true;
    },
    audioMoney2Click() {
      if (this.agentLevel === 1) return;
      if (this.rewardData.audioMoney2.resValue === '0') {
        this.audioMoney2Slots[0].values = [0];
      } else {
        this.audioMoney2Slots[0].values = this.audioPickerSlotsChange(this.rewardData.audioMoney2.resValue, this.rewardData.audioMoney2.minValue);
      }
      this.audioMoney2SelectVisible = true;
    },
    firstBonusClick() {
      if (this.agentLevel === 1) return;
      if (this.rewardData.money1.resValue === '0') {
        this.firstRewordMoneySlots[0].values = [0];
      } else {
        this.firstRewordMoneySlots[0].values = this.pickerSlotsChange(this.rewardData.money1.resValue, this.rewardData.money1.minValue);
      }
      this.firstSelectVisible = true;
    },
    secondBonusClick() {
      if (this.agentLevel === 1) return;
      if (this.rewardData.money2.resValue === '0') {
        this.secondRewordMoneySlots[0].values = [0];
      } else {
        this.secondRewordMoneySlots[0].values = this.pickerSlotsChange(this.rewardData.money2.resValue, this.rewardData.money2.minValue);
      }
      this.secondSelectVisible = true;
    },
    thirdBonusClick() {
      if (this.agentLevel === 1) return;
      if (this.rewardData.money3.resValue === '0') {
        this.rewordMoneySlots[0].values = [0];
      } else {
        this.rewordMoneySlots[0].values = this.pickerSlotsChange(this.rewardData.money3.resValue, this.rewardData.money3.minValue);
      }
      this.selectVisible = true;
    },
    xwmoneyPopupClick() {
      if (!this.rewardData.xwmoney.minValue && !this.rewardData.xwmoney.minValue) {
        CusToast('金额设置最大值为0');
        return;
      }
      this.xwRewordMoneySlots[0].values = this.XWpickerSlotsChange(this.rewardData.xwmoney.resValue, this.rewardData.xwmoney.minValue);
      this.xwSelectVisible = true;
    },
    // 保存picker金额选择
    handleSelectSave() {
      const data = this.pickerRewardData.currentSelect;
      this.rewardData.money3.value = data;
      this.selectVisible = false;
    },
    firstHandleSelectSave() {
      // 对应修改money1
      const data = this.pickerRewardData.firstCurrentSelect;
      this.rewardData.money1.value = data;
      this.firstSelectVisible = false;
    },
    secondHandleSelectSave() {
      const data = this.pickerRewardData.secondCurrentSelect;
      this.rewardData.money2.value = data;
      this.secondSelectVisible = false;
    },
    audioMoney1HandleSelectSave() {
      const data = this.pickerRewardData.audioMoney1CurrentSelect;
      this.rewardData.audioMoney1.value = data;
      this.audioMoney1SelectVisible = false;
    },
    audioMoney2HandleSelectSave() {
      const data = this.pickerRewardData.audioMoney2CurrentSelect;
      this.rewardData.audioMoney2.value = data;
      this.audioMoney2SelectVisible = false;
    },
    xwHandleSelectSave() {
      const data = this.pickerRewardData.xwCurrentSelect;
      this.rewardData.xwmoney.value = data;
      this.xwSelectVisible = false;
    },
    // 复选框svg切换
    handleCheckBoxClick4() {
      // 达标额外奖励
      this.currentCheckedState4 = !this.currentCheckedState4;
      this.checkboxSvgPath4 = this.currentCheckedState4 ? 'selected_coupons' : 'unselected_coupons';
      this.checkboxColor4 = this.currentCheckedState4 ? 'selected_color' : 'unselected_color';
      this.rewardData.money4.value = this.currentCheckedState4 ? 10 : 0;
    },
    handleCheckBoxClick5() {
      // 优质商户额外达标
      this.currentCheckedState5 = !this.currentCheckedState5;
      this.checkboxSvgPath5 = this.currentCheckedState5 ? 'selected_coupons' : 'unselected_coupons';
      this.checkboxColor5 = this.currentCheckedState5 ? 'selected_color' : 'unselected_color';
      this.rewardData.money5.value = this.currentCheckedState5 ? 10 : 0;
    },
    // 根据接口返回值初始化显示数据
    setRewardData(res) {
      this.rewardData.allowChangeReward = res.data.allowChangeReward;
      // 营业执照进件相关奖励
      if (this.agentLevel === 1) {
        this.rewardData.allowChangeReward = 1;
        this.rewardData.money1.value = this.formatMoneyToYuanShow(res.data.firstRewardMoney);
        this.rewardData.money2.value = this.formatMoneyToYuanShow(res.data.secondRewardMoney);
        this.rewardData.money3.value = this.formatMoneyToYuanShow(res.data.thirdRewardMoney);
        this.rewardData.money4.value = this.formatMoneyToYuanShow(res.data.extraSecondBonus);
        this.rewardData.money5.value = this.formatMoneyToYuanShow(res.data.extraThirdBonus);
        this.rewardData.audioMoney1.value = this.formatMoneyToYuanShow(res.data.soundSecondRewardMoney);
        this.rewardData.audioMoney2.value = this.formatMoneyToYuanShow(res.data.soundThirdRewardMoney);
        // 额外奖励svg选中
        this.checkboxSvgPath4 = res.data.extraSecondBonus === 1000 ? 'selected_coupons' : 'unselected_coupons';
        this.checkboxColor4 = res.data.extraSecondBonus === 1000 ? 'selected_color' : 'unselected_color';
        this.currentCheckedState4 = res.data.extraSecondBonus === 1000;
        this.checkboxSvgPath5 = res.data.extraThirdBonus === 1000 ? 'selected_coupons' : 'unselected_coupons';
        this.checkboxColor5 = res.data.extraThirdBonus === 1000 ? 'selected_color' : 'unselected_color';
        this.currentCheckedState5 = res.data.extraThirdBonus === 1000;
        this.rewardData.allowChangeSoundReward = 1;
      } else {
        if (res.data.allowChangeReward === 0) {
          this.rewardData.money1.value = 0;
          this.rewardData.money2.value = 0;
          this.rewardData.money3.value = 0;
          this.rewardData.audioMoney1.value = 0;
          this.rewardData.audioMoney2.value = 0;
        } else {
          this.rewardData.money1.value = res.data.firstRewardMoney === -1 ? '' : this.formatMoneyToYuanShow(res.data.firstRewardMoney);
          this.rewardData.money2.value = res.data.firstRewardMoney === -1 ? '' : this.formatMoneyToYuanShow(res.data.secondRewardMoney);
          this.rewardData.money3.value = res.data.firstRewardMoney === -1 ? '' : this.formatMoneyToYuanShow(res.data.thirdRewardMoney);
          this.rewardData.audioMoney1.value = res.data.soundSecondRewardMoney === -1 ? '' : this.formatMoneyToYuanShow(res.data.soundSecondRewardMoney);
          this.rewardData.audioMoney2.value = res.data.soundThirdRewardMoney === -1 ? '' : this.formatMoneyToYuanShow(res.data.soundThirdRewardMoney);

          if (!res.data.allowChangeSoundReward) {
            // 不能设置音箱奖励
            this.checkTextColor = 'disable_color';
            this.rewardData.allowChangeSoundReward = 0;
            this.rewardData.audioMoney1.value = '请选择';
            this.rewardData.audioMoney2.value = '请选择';
          } else {
            this.rewardData.allowChangeSoundReward = 1;
          }
        }
      }
      // 小微达标奖励
      this.rewardData.xwmoney.allowChangeActiveReward = res.data.allowChangeActiveReward;
      if (this.rewardData.xwmoney.allowChangeActiveReward) {
        // 允许设置
        if (!res.data.minActiveRewardMoney && !res.data.maxActiveRewardMoney) {
          // 最大最小可设置值都为0
          this.rewardData.xwmoney.value = 0;
          this.rewardData.xwmoney.minValue = 0;
          this.rewardData.xwmoney.maxValue = 0;
        } else {
          this.rewardData.xwmoney.value = this.formatMoneyToYuanShow(res.data.activeRewardMoney);
          this.rewardData.xwmoney.minValue = this.formatMoneyToYuanShow(res.data.minActiveRewardMoney);
          this.rewardData.xwmoney.maxValue = this.formatMoneyToYuanShow(res.data.maxActiveRewardMoney);
          // 第一次设置
          if (res.data.activeRewardMoney === -1) {
            // this.rewardData.xwmoney.value = this.formatMoneyToYuanShow(res.data.maxActiveRewardMoney);
            this.rewardData.xwmoney.value = '';
          }
        }
      } else {
        // 不允许设置
        this.rewardData.xwmoney.value = 0;
        this.rewardData.xwmoney.minValue = 0;
        this.rewardData.xwmoney.maxValue = 0;
      }
    },
    // 初始化可选择最大值
    setResValue(data) {
      // 营业执照
      if (data.allowChangeReward) {
        // 最大值
        this.rewardData.money1.resValue = this.formatMoneyToYuanShow(data.maxFirstRewardMoney);
        this.rewardData.money2.resValue = this.formatMoneyToYuanShow(data.maxSecondRewardMoney);
        this.rewardData.money3.resValue = this.formatMoneyToYuanShow(data.maxThirdRewardMoney);
        // 最小值
        this.rewardData.money1.minValue = this.formatMoneyToYuanShow(data.minFirstRewardMoney);
        this.rewardData.money2.minValue = this.formatMoneyToYuanShow(data.minSecondRewardMoney);
        this.rewardData.money3.minValue = this.formatMoneyToYuanShow(data.minThirdRewardMoney);
      }
      // 音箱码牌
      if (data.allowChangeSoundReward) {
        this.rewardData.audioMoney1.resValue = this.formatMoneyToYuanShow(data.soundMaxSecondRewardMoney);
        this.rewardData.audioMoney2.resValue = this.formatMoneyToYuanShow(data.soundMaxThirdRewardMoney);
        this.rewardData.audioMoney1.minValue = this.formatMoneyToYuanShow(data.soundMinSecondRewardMoney) || 0;
        this.rewardData.audioMoney2.minValue = this.formatMoneyToYuanShow(data.soundMinThirdRewardMoney) || 0;
      }
      // 小微
      if (data.allowChangeActiveReward) {
        this.rewardData.xwmoney.resValue = this.formatMoneyToYuanShow(data.maxActiveRewardMoney);
      }
    },
    // 查询活动奖励设置
    showTaskRewardSetting(callback = null) {
      CusLoadingOpen();
      ShowTaskRewardSetting({ id: this.$route.query.agentid })
        .then(res => {
          // CusToast(res.msg);
          CusLoadingClose();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              // code=0
              this.$nextTick(() => {
                this.setRewardData(res);
                this.setResValue(res.data);
              });
            },
            (code, msg) => {
              msg && CusToast(msg);
              // code=1
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 保存营业执照相关奖励设置
    changeTaskRewardSetting(callback = null) {
      CusLoadingOpen();
      const param = {
        extraFirstBonus: 0,
        extraSecondBonus: parseInt(formatMoneyToFen(this.rewardData.money4.value)),
        extraThirdBonus: parseInt(formatMoneyToFen(this.rewardData.money5.value)),
        firstRewardMoney: parseInt(formatMoneyToFen(this.rewardData.money1.value)),
        id: this.$route.query.agentid,
        secondRewardMoney: parseInt(formatMoneyToFen(this.rewardData.money2.value)),
        thirdRewardMoney: parseInt(formatMoneyToFen(this.rewardData.money3.value)),
        soundSecondRewardMoney: parseInt(formatMoneyToFen(this.rewardData.audioMoney1.value)),
        soundThirdRewardMoney: parseInt(formatMoneyToFen(this.rewardData.audioMoney2.value)),
      };
      if (!this.rewardData.allowChangeSoundReward) {
        param.soundSecondRewardMoney = -1;
        param.soundThirdRewardMoney = -1;
      }
      ChangeTaskRewardSetting(param)
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              CusAlert('营业执照商户奖励保存成功', () => {
                this.$router.go(-1);
              });
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 保存小微奖励设置
    saveXWMoney() {
      this.validateMoney(() => {
        this.changeXWSHTaskRewardSetting();
      });
    },
    changeXWSHTaskRewardSetting() {
      CusLoadingOpen();
      const param = {
        id: this.$route.query.agentid,
        activeRewardMoney: parseInt(formatMoneyToFen(this.rewardData.xwmoney.value)),
      };
      ChangeXWSHTaskRewardSetting(param)
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              CusAlert('小微商户奖励保存成功', () => {
                this.$router.go(-1);
              });
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 返回单击事件
    onBackBtnClick() {
      this.$router.go(-1);
    },
    // 营业执照商户设置保存按钮事件
    onPageSubmitClick() {
      this.bussinessValidateMoney(() => {
        this.changeTaskRewardSetting();
      });
    },
    // 数据验证
    bussinessValidateMoney(callback = null) {
      const money1Err = validateZhenMoney(this.rewardData.money1.value);
      const money2Err = validateZhenMoney(this.rewardData.money2.value);
      const money3Err = validateZhenMoney(this.rewardData.money3.value);
      const audioMoney1Err = validateZhenMoney(this.rewardData.audioMoney1.value);
      const audioMoney2Err = validateZhenMoney(this.rewardData.audioMoney2.value);
      if (!money1Err && !money2Err && !money3Err && !audioMoney1Err && !audioMoney2Err) {
        callback && callback();
      } else {
        if (money1Err === 1) {
          CusToast('激活奖励金额不能为空');
          return;
        }
        if (money2Err === 1) {
          CusToast('达标奖励金额不能为空');
          return;
        }
        if (money3Err === 1) {
          CusToast('优质商户奖励金额不能为空');
          return;
        }
        if (audioMoney1Err === 1) {
          CusToast('音箱码牌达标奖励金额不能为空');
          return;
        }
        if (audioMoney2Err === 1) {
          CusToast('音箱码牌优质商户奖励金额不能为空');
          return;
        }
      }
    },
    validateMoney(callback = null) {
      const xwMoneyErr = validateZhenMoney(this.rewardData.xwmoney.value);
      const xwMoneyMinMaxErr = validateMinMax(this.rewardData.xwmoney.value, this.rewardData.xwmoney.minValue, this.rewardData.xwmoney.maxValue);
      if (!xwMoneyErr && !xwMoneyMinMaxErr) {
        callback && callback();
      } else {
        if (xwMoneyErr === 1) {
          CusToast('小微达标奖励金额不能为空');
          return;
        }
        if (xwMoneyErr === 2) {
          CusToast('小微达标奖励金额只能是整数');
          return;
        }
        if (xwMoneyErr === 3) {
          CusToast('请输入合法的小微达标奖励金额');
          return;
        }
        if (xwMoneyMinMaxErr === 1) {
          CusToast(`小微达标奖励金额不能高于${this.rewardData.xwmoney.maxValue}（元）`);
          return;
        }
        if (xwMoneyMinMaxErr === 2) {
          CusToast(`小微达标奖励金额不能低于${this.rewardData.xwmoney.minValue}（元）`);
          return;
        }
      }
    },
    // 不能设置时的点击提示
    onXWMoneyClick() {
      if (!this.rewardData.xwmoney.allowChangeActiveReward) {
        CusToast('您没有修改此奖励金额的权限');
      }
    },
    // 控制营业执照奖励设置弹出框
    rewardMoneyVisibleChange() {
      if (this.rewardData.allowChangeReward) {
        this.BigPopVisible = true;
        this.showTaskRewardSetting();
      } else {
        CusToast('您没有权限设置此奖励');
      }
    },
    // 控制小微奖励设置弹出框
    XWMoneyVisibleChange() {
      if (this.rewardData.xwmoney.allowChangeActiveReward) {
        this.xwMoneyPopVisible = true;
        this.showTaskRewardSetting();
      } else {
        CusToast('您没有权限设置此奖励');
      }
    },
  },
};
</script>

<style scoped>
.bg {
  background-color: #f5f5f5;
}
input[type='text'] {
  text-align: right;
  padding-right: 0.8rem !important;
}
.row .content .unselected_color {
  color: #b4b4b4 !important;
}
.row .content .selected_color {
  color: #000 !important;
}
.form .num-checkbox {
  float: right;
  margin-right: 0.6rem;
}
.form .num-checkbox span {
  margin-left: 0.2rem;
  vertical-align: middle;
}
.able_color {
  color: #000 !important;
}
.disable_color {
  color: #b4b4b4 !important;
}
</style>
